const ITEM_IMAGE_MODULES = import.meta.glob(
  "/src/assets/images/items/**/*.webp",
  { eager: true, import: "default" }
) as Record<string, string>

const codeFromPath = (path: string): string => {
  const fileName = path.split("/").pop() ?? ""
  return fileName.replace(/\.webp$/, "")
}

const ITEM_IMAGE_BY_CODE: Record<string, string> = Object.fromEntries(
  Object.entries(ITEM_IMAGE_MODULES).map(([path, url]) => [
    codeFromPath(path),
    url
  ])
)

export const resolveItemImage = (definitionCode: string): string | undefined =>
  Object.hasOwn(ITEM_IMAGE_BY_CODE, definitionCode)
    ? ITEM_IMAGE_BY_CODE[definitionCode]
    : undefined
